<template>
  <div
    class='event-wrapper'
    :class="[
      active ? 'active' : '',
      highlighted ? `relative isolate self-stretch opacity-100! before:absolute before:-left-10.25 before:right-0
                     before:-inset-y-1 before:-z-1 before:rounded-control before:bg-row-alt` : '',
    ]">
    <UserAvatar
      class="user-avatar"
      :user="getUser(taskEvent.user.id)"
      :fromMcp="taskEvent.fromMcp"
    />
    <div class="user-name">{{ taskEvent.user.username }}</div>
    <div
      v-for="(event, index) in eventsToDisplay"
      :key="index"
      class="event"
      :class="event.action.includes('_manual_time') && 'min-w-0 flex-1'">
      <Time class="event-time" :time="event.date"/>
      <div class="min-w-0">
        <div  class="event-text" v-if="event.action === 'create_task'">
          {{ $t('task.Created_task_in')
           }} <b style="margin-left: 3px;">{{ event.stage.name }}</b>
        </div>
        <div  class="event-text" v-if="event.action === 'transfer_task'">
          {{ $t('task.Transferred_task_from')
           }} <b style="margin-left: 3px;">{{ event.rawPayload.fromProjectName }}</b>
        </div>
        <div  class="event-text" v-if="event.action === 'change_description'">
          {{ $t('task.Changed_task_description') }}
        </div>
        <div class="event-text" v-if="event.action === 'set_assignee'">
          <div>{{ $t('task.Assigned') }}</div>
          <UserAvatar
            class="user-avatar"
            :user="getUser(event.affectedUserId)"
          />
          <div v-if="event.payload && event.rawPayload.rule" style="margin-left: 10px;">
            {{ $t('task.by_trigger') }}
          </div>
        </div>
        <div class="event-text" v-if="event.action === 'remove_assignee'">
          {{ $t('task.Removed_assignee') }}
           {{ event.payload && event.rawPayload.rule ? $t('task.by_trigger') : ''}}
        </div>
        <div class="event-text" v-if="event.action === 'move_task'">
          {{ $t('task.Moved_to') }} <b :style="`margin: 0 3px 0
           ${event.payload && event.rawPayload.rule
            ? '3px' : ''};`">{{ getStageName(event.stageId) }}</b>{{ event.payload
            && event.rawPayload.rule  ? $t('task.by_trigger') : ''}}
        </div>
        <div class="event-text" v-if="event.action === 'set_label'">
          <div>{{ $t('task.Added_tag') }}</div>
          <div
            class="tag tag-tint"
            :style="{ '--tag-color': `#${event.rawPayload.color}` }">
            <div class="tag-name" :title="event.rawPayload.name">
              {{ event.rawPayload.name }}
            </div>
          </div>
        </div>
        <div class="event-text" v-if="event.action === 'remove_label'">
          <div>{{ $t('task.Removed_tag') }}</div>
          <div
            class="tag tag-tint"
            :style="{ '--tag-color': `#${event.rawPayload.color}` }">
            <div class="tag-name" :title="event.rawPayload.name">
              {{ event.rawPayload.name }}
            </div>
          </div>
        </div>
        <div class="event-text" v-if="event.action === 'change_estimate'">
          {{ $t('task.Set_estimate_to') }} <b style="margin-left: 3px;">{{ event.payload }}</b>
        </div>
        <div class="event-text" v-if="event.action === 'change_priority'">
          <i v-if="event.priority" :class="`tr tr-priority-${event.priority}`"></i>
          <div>{{ $t('task.Set_priority') }}
             {{ !event.priority ? $t('task.to_normal') : '' }}</div>
        </div>
        <div class="event-text min-w-0" v-if="event.action === 'add_manual_time'">
          <i class="tr tr-manual-time"></i>
          <div class="shrink-0 whitespace-nowrap">{{ $t('task.Added') }}</div>
          <SpentTime class="mx-1 font-bold" :seconds="event.rawPayload.duration" />
          <div class="manual-description max-sm:max-w-full!"
            :title="event.rawPayload.description"
            >
            "{{ event.rawPayload.description}}"
          </div>
          <ConfirmButton
            v-if="event.userId === user.id && manualTimeObject(event)
              && manualTimeObject(event).status === 'approved'"
            class="remove-manualtime-btn"
            :buttonText="$t('task.REMOVE')"
            :popupTitle="$t('task.Are_you_sure')"
            @confirm="deleteManualTime(manualTimeObject(event))"
            @popup-open="active = true;"
            @popup-close="active = false;">
          </ConfirmButton>
        </div>
        <div class="event-text min-w-0" v-else-if="event.action === 'request_manual_time'">
          <i class="tr tr-manual-time"></i>
          <div class="shrink-0 whitespace-nowrap">{{ $t('task.Reqested_to_add') }}</div>
          <SpentTime class="mx-1 font-bold" :seconds="event.rawPayload.duration" />
          <div class="manual-description max-sm:max-w-full!"
            :title="event.rawPayload.description"
            >
            "{{ event.rawPayload.description}}"
          </div>
          <div v-if="event.userId === user.id && manualTimeObject(event)">
            <ConfirmButton
              v-if="event.userId === user.id && manualTimeObject(event)
                && manualTimeObject(event).status === 'pending'"
              class="remove-manualtime-btn"
              :buttonText="$t('task.manual_CANCEL')"
              :popupTitle="$t('task.Are_you_sure')"
              @confirm="deleteManualTime(manualTimeObject(event))"
              @popup-open="active = true;"
              @popup-close="active = false;">
            </ConfirmButton>
          </div>
        </div>
        <div class="event-text min-w-0" v-else-if="event.action.includes('_manual_time')">
          <i class="tr tr-manual-time"></i>
          <div v-if="event.action === 'approved_manual_time'" class="shrink-0 whitespace-nowrap">{{ $t('task.Approved') }}</div>
          <div v-if="event.action === 'rejected_manual_time'" class="shrink-0 whitespace-nowrap">{{ $t('task.Rejected') }}</div>
          <div v-if="event.action === 'canceled_manual_time'" class="shrink-0 whitespace-nowrap">{{ $t('task.Canceled') }}</div>
          <div v-if="event.action === 'deleted_manual_time'" class="shrink-0 whitespace-nowrap">{{ $t('task.Deleted') }}</div>
          <SpentTime class="mx-1 font-bold" :seconds="event.rawPayload.duration" />
          <div class="manual-description max-sm:max-w-full!"
            :title="event.rawPayload.description"
            >
            "{{ event.rawPayload.description}}"
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import Time from '@/components/elements/Time';
import ConfirmButton from '@/components/elements/ConfirmButton';
import SpentTime from '@/components/elements/SpentTime.vue';

const props = defineProps({
  taskEvent: Object,
  task: Object,
  // scrolled-to target: same rounded background as a hovered comment
  highlighted: Boolean,
});

const store = useStore();

const payload = ref(props.taskEvent.payload ? JSON.parse(props.taskEvent.payload) : {});
const active = ref(false);

const getStageName = computed(() => store.getters['project/getStageName']);
const getUser = computed(() => store.getters['user/getUser']);
const user = computed(() => store.state.user.user);

const eventsToDisplay = computed(() => {
  let result = [props.taskEvent];
  if (props.taskEvent.groupEventText) {
    result = result.concat(JSON.parse(props.taskEvent.groupEventText));
  }
  return result.map(
    r => ({
      ...r,
      rawPayload: JSON.parse(r.payload),
    }),
  );
});

const manualTimeObject = computed(() => (event) => {
  const { manualTimeId } = event.rawPayload;
  if (props.task && props.task.requestedTimeSlots) {
    return props.task.requestedTimeSlots.find(mt => mt.id === manualTimeId) || null;
  }
  return null;
});

const deleteManualTime = async (mt) => {
  let newStatus = '';
  if (mt.status === 'pending') {
    // if it still was not accepted - then we allow to cancel
    newStatus = 'canceled';
  } else {
    newStatus = 'deleted';
  }
  const applied = await store.dispatch('project/actionUpdateManualTime', {
    id: mt.id,
    taskHid: props.task.hid,
    status: newStatus,
  });
  if (applied && newStatus === 'deleted') {
    const ttbu = props.task.taskTrackedByUsers.find(t => t.userId === mt.userId);
    if (ttbu) {
      store.dispatch('project/actionUpdateTTBU', {
        ttbu: {
          ...ttbu,
          totalSeconds: ttbu.totalSeconds - mt.duration,
        },
      });
    }
  }
};
</script>

<style lang='scss' scoped>

    .remove-manualtime-btn :deep(.button) {
      margin-left: 10px;
      padding: 6px 10px;
      min-height: auto;
    }


  .event-wrapper {
    cursor: default;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 0.375rem;
    opacity: 0.6;
    &.active {
      opacity: 1;
    }
    .user-avatar {
      cursor: default!important;
      width: 18px;
      height: 18px;

      :deep(.content) {
        font-size: 10px;
      }
    }

    .user-name {
      margin: 0 10px;
      font-size: 12px;
      color: var(--text);
      font-weight: bold;
      white-space: nowrap;
    }

    .manual-description {
      max-width: 15vw;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .event {
      display: flex;
      align-items: center;
      margin-right: 10px;
      line-height: 20px;

      .event-time {
        font-size: 12px;
        color: var(--accent);
      }

      .event-text {
        display: flex;
        font-size: 12px;
        margin-left: 10px;
        align-items: center;
        color: var(--text);

        .tag {
          margin: 1px 0 0 10px;
          max-width: 48px;
          height: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 6px;
          border-radius: 5px;

          .tag-name {
            font-size: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .user-avatar {
          cursor: default;
          margin-left: 10px;
        }

        .tr {
          display: flex;
          align-items: center;
          margin-right: 10px;
          color: var(--accent);

          &.tr-manual-time {
            color: var(--text);
          }
        }
      }
    }

    .event:last-child {
      margin-right: 0;
    }
  }
  .event-wrapper:hover {
    opacity: 1;
  }

</style>
